module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Kè Su Thar was born in 1965, in Aung Lan, a small town of Burma (Myanmar). His parents were so poor that they could not afford to school him. Hence, his formal education ended early in his childhood, in primary level. However, he never gave up learning. He taught and groomed himself.")]), _vm._v(" "), _c('p', [_vm._v("He has written some short stories and three novels—"), _c('em', [_vm._v("Karzu, Forgotten Biography")]), _vm._v(" and "), _c('em', [_vm._v("His Day")]), _vm._v("—all in Burmese. His short stories have appeared in some magazines. This is his first novel written in English. Now he lives in Yangon with his elder sister’s family.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2486c48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch001.vue
// module id = 63
// module chunks = 0